import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

import styled from 'styled-components';
import BookElement from 'app/api/bookElement';

import {
  Accordion as GrommetAccordion,
  AccordionPanel as GrommetAccordionPanel,
  Box,
  Text,
} from 'grommet';
import Paragraph from 'app/components/Paragraph'
import { Player as ReactPlayer } from 'video-react';

import 'app/style/media-player.css';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const Container = styled.div`
  max-width: 600px;
  max-height: 600px;
  margin: 32px auto;
`;

const Player = styled(ReactPlayer)`
  font-family: inherit !important;
`;

const Accordion = styled(GrommetAccordion)`
  width: 100%;
  max-width: 600px;
  overflow: hidden;
`;

const AccordionPanel = styled(GrommetAccordionPanel)`
  height: 40px;
`;

const AccordionContent = styled(Box)`
  height: 150px;
  overflow-y: auto;
  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5) inset;
  padding: 0 6px;
`;

class Media extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    return (
      <Container aria-label={content.caption}>
        <ScrollIntoViewIfNeeded
          options={scrollIntoViewOptions}
          active={_.isEqual(path, AppState.selectedSectionItem)}
        >
          <Box align="center">
            <Player
              aria-label="media player"
              position="center"
              alt={content.caption}
              poster={require('../../../content' + content.poster)}
            >
              <source src={require('../../../content' + content.source)} />
            </Player>
            {content.transcript && (
              <Accordion animate={false}>
                <AccordionPanel background="light-4" label="transcript">
                  <AccordionContent>
                    <Paragraph>{content.transcript}</Paragraph>
                  </AccordionContent>
                </AccordionPanel>
              </Accordion>
            )}
            <Text weight="bold" textAlign="center">
              {BookElement.extractTitleFromPath(path)} — {content.caption}
            </Text>
          </Box>
        </ScrollIntoViewIfNeeded>
      </Container>
    );
  }
}

Media.propTypes = {
  /**
   * content path
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * source, caption, poster, prefix, transcript
   */
  content: PropTypes.shape({
    source: PropTypes.string.isRequired,
    caption: PropTypes.string.isRequired,
    poster: PropTypes.string.isRequired,
    transcript: PropTypes.string,
    prefix: PropTypes.string,
  }),
};
Media.defaultProps = {
  content: {},
};

const Component = inject('AppState')(observer(Media));
Component.displayName = 'Media';
export const MediaComponent = Media;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Media.js